import { makeStyles } from "@material-ui/core";

export const drawerWidth = 275;

export const sideStyles = makeStyles((theme) => ({
  Drawer: {
    width: drawerWidth,
    zIndex: theme.zIndex.appBar - 1,
  },
  List: {
    width: drawerWidth,
  },
  ListItem: {
    cursor: "pointer",
    height: "2.5em",
  },
  ListItemText: {
    paddingLeft: "20%",
  },
  activeLink: {
    backgroundColor: "#1E91C2",
    color: "white",
  },
  activeTitle: {
    color: theme.palette.primary.main,
    cursor: "pointer",
    height: "2.5em",
  },
  activeIcon: {
    color: theme.palette.primary.main,
  },
  Avatar: {
    width: theme.spacing(3),
    paddingTop: theme.spacing(0.5),
    height: theme.spacing(3),
    fontSize: "15px",
    color: theme.palette.primary.dark,
    backgroundColor: "white",
  },

  activelistItem: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  activelistIcon: {
    color: "white",
  },
}));
